module.exports = __webpack_public_path__ + "static/media/4f.c471374b.jpg";